import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { FaRegTrashAlt, FaShoppingCart } from 'react-icons/fa';
//
import Layout from '../../components/Layout';
import { Title } from '../../components/ui';
//
import ItemTable from '../../components/ItemTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  createCartFromFavorites,
  getFavorites,
  removeFavorites,
  updateFavorites,
} from '../../api/services/favoritesService';
import { setShowLoading } from '../../redux/systemInfo';
import { useGuestCheck } from '../../hooks/useGuestCheck';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.white};
  padding-top: 5vh;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding-top: 50px;
  }

  @media (max-width: 480px) {
    min-height: 90vh;
    padding-top: 30px;
  }
`;

const BottomButtonContainer = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-bottom: 3%;
`;

const Button = styled.button`
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  padding: 10px 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  border-radius: 10px;

  &:hover {
    opacity: 0.8;
  }
`;

export default function FavoritesPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const { isGuestUser } = useGuestCheck();

  useEffect(() => {
    getDbFavoritesList();
  }, []);

  const [favoritesList, setFavoritesList] = useState([]);

  const getDbFavoritesList = async () => {
    const result = await getFavorites(userInfo.idCustomer, userInfo.idStore);
    if (result.is_success) {
      setFavoritesList(result.favorites);
    }
  };

  const handleUpdateFavorites = async (item, quantity) => {
    const result = await updateFavorites(
      userInfo.idCustomer,
      item.idWishlist,
      quantity,
    );
    if (result.is_success) {
      getDbFavoritesList();
    }
  };

  const handleRemoveFavorites = async (item) => {
    const result = await removeFavorites(userInfo.idCustomer, item.idWishlist);
    if (result.is_success) {
      alert('Remove from Favorites Success!');
      getDbFavoritesList();
    }
  };

  const handleClearFavorites = async () => {
    dispatch(setShowLoading({ showLoading: true }));

    const taskList = [];
    for (const favorite of favoritesList) {
      taskList.push(removeFavorites(userInfo.idCustomer, favorite.idWishlist));
    }
    await Promise.all(taskList);
    dispatch(setShowLoading({ showLoading: false }));
    getDbFavoritesList();
  };

  const handleAddToCart = async () => {
    dispatch(setShowLoading({ showLoading: true }));
    const result = await createCartFromFavorites(userInfo.idCustomer);
    if (result.is_success) {
      alert('Cart created successfully!');
      navigate('/cart');
    } else {
      alert(result.message);
    }
    dispatch(setShowLoading({ showLoading: false }));
  };

  return (
    <Layout>
      <Container>
        <Title style={{ marginBottom: '20px' }}>Favorites</Title>
        {favoritesList && favoritesList.length > 0 ? (
          <>
            <ItemTable
              data={favoritesList}
              style={{ width: '80%' }}
              updateData={(item, quantity) => {
                handleUpdateFavorites(item, quantity);
              }}
              removeData={(item) => {
                handleRemoveFavorites(item);
              }}
            />
          </>
        ) : (
          <div
            style={{
              marginTop: '100px',
              marginBottom: '100px',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              color: '#666',
            }}
          >
            <div>No favorites found.</div>
          </div>
        )}
        <BottomButtonContainer>
          <Button
            onClick={() => {
              handleAddToCart();
            }}
            disabled={isGuestUser}
            style={{
              opacity: isGuestUser ? 0.5 : 1,
              cursor: isGuestUser ? 'not-allowed' : 'pointer',
            }}
          >
            <FaShoppingCart style={{ marginRight: '10px' }} />
            {isGuestUser ? 'Guest - Cart Disabled' : 'Add All Items to Cart'}
          </Button>
          <Button
            style={{ background: theme.colors.primaryRed }}
            onClick={() => {
              handleClearFavorites();
            }}
          >
            <FaRegTrashAlt style={{ marginRight: '10px' }} />
            Clear Favorites
          </Button>
        </BottomButtonContainer>
      </Container>
    </Layout>
  );
}
